import { z } from 'zod';

const namePattern = /^[\p{L}' -]+$/u;

export const subscribeSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, 'First name is required')
    .max(50, 'First name must be 50 characters or fewer')
    .regex(namePattern, 'First name contains invalid characters'),
  lastName: z
    .string()
    .trim()
    .min(1, 'Last name is required')
    .max(50, 'Last name must be 50 characters or fewer')
    .regex(namePattern, 'Last name contains invalid characters'),
  dateOfBirth: z
    .date({
      required_error: 'Date of birth is required',
    })
    .refine(isAtLeast21YearsOld, {
      message: 'You must be 21 or older',
    }),
  email: z
    .string()
    .trim()
    .min(1, 'Email is required')
    .max(254, 'Email must be 254 characters or fewer')
    .email('Invalid email address'),
  zipCode: z
    .string()
    .min(1, 'Zip code is required')
    .regex(/^\d{5}(?<temp1>-\d{4})?$/, 'Invalid zip code'),
  state: z.string().min(1, 'State is required').max(64, 'State is too long'),
  terms: z.literal(true, {
    errorMap: () => ({
      message: 'You must accept the terms',
    }),
  }),
});

function isAtLeast21YearsOld(birthDate: Date): boolean {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const birth = new Date(birthDate);
  birth.setHours(0, 0, 0, 0);
  const twentyFirstBirthday = new Date(birth);
  twentyFirstBirthday.setFullYear(twentyFirstBirthday.getFullYear() + 21);
  return twentyFirstBirthday <= today;
}

export type SubscribeSchema = z.infer<typeof subscribeSchema>;
